import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel } from "mobx-utils";
import * as React from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { toast } from "react-toastify";
import MomentLocaleUtils from "react-day-picker/moment";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import { IMonofasicoSimples } from "../../model";
import * as moment from "moment";
import { MonofasicoStore } from "../../stores/legislacao/MonofasicoStore";
const InputMask = require("react-input-mask");

interface Props {
  monofasico: IMonofasicoSimples;
  onClose: () => void;
}

interface State {
}

@observer
export class MonofasicoSimplesDuplicar extends React.Component<Props, State>{
  obs = observable({
    monofasico_duplicar: {} as IMonofasicoSimples
  })

  async componentDidMount() {
    this.obs.monofasico_duplicar = createViewModel(observable(this.props.monofasico));
  }

  handleSaveDuplica = async (monofasico) => {

    if (monofasico.ncm == "") {
      toast.error(`NCM obrigatório!`, {});
      return
    }

    if (monofasico.descricao == "") {
      toast.error(`Descrição obrigatória!`, {});
      return
    }

    var valido_de = monofasico.valido_de ? moment(monofasico.valido_de).format("YYYY-MM-DD") : null;
    var valido_ate = monofasico.valido_ate ? moment(monofasico.valido_ate).format("YYYY-MM-DD") : null;

    if (valido_de != null && valido_ate != null) {
      if (valido_de > valido_ate) {
        toast.warning('Campo (Valido de) não pode ser maior que (Valido até)', {});
        return;
      }
    }

    let params = {
      item: monofasico.item,
      ncm: monofasico.ncm,
      descricao: monofasico.descricao,
      legislacao: monofasico.legislacao,
      valido_de: valido_de,
      valido_ate: valido_ate
    }

    this.props.onClose()

    await MonofasicoStore.doSaveDuplica(params)
  };

  render() {
    if (!this.obs.monofasico_duplicar) {
      return null;
    }
    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <Dialog
        isOpen={true}
        title={"Duplicar Monofásico"}
        onClose={this.props.onClose}
        style={{ width: 600, height: 400 }}
      >
        <div className={Classes.DIALOG_BODY}>
          <div style={{ marginTop: 0 }}>

            <FormGroup label="Item" labelFor="item">
              <InputGroup
                type="text"
                onChange={(e) => this.obs.monofasico_duplicar.item = e.target.value}
                value={this.obs.monofasico_duplicar.item}
              />
            </FormGroup>

            <FormGroup
              label="NCM"
              labelFor="ncm"
            >
              <InputMask
                mask="9999.99.99"
                className="form-control"
                onChange={(e) => this.obs.monofasico_duplicar.ncm = e.target.value}
                value={this.obs.monofasico_duplicar.ncm}
              />
            </FormGroup>

            <FormGroup label="Descrição" labelFor="aliquota">
              <InputGroup
                type="text"
                onChange={(e) => this.obs.monofasico_duplicar.descricao = e.target.value}
                value={this.obs.monofasico_duplicar.descricao}
              />
            </FormGroup>

            <FormGroup label="Legislação" labelFor="legislacao">
              <InputGroup
                type="text"
                onChange={(e) => this.obs.monofasico_duplicar.legislacao = e.target.value}
                value={this.obs.monofasico_duplicar.legislacao}
              />
            </FormGroup>

            <MDBRow xl="12" lg="12" md="12" sm="12" xs="12">
              <MDBCol>

                <FormGroup label="Valido de">
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    value={this.obs.monofasico_duplicar.valido_de ? new Date(this.obs.monofasico_duplicar.valido_de) : null}
                    onChange={(e) => this.obs.monofasico_duplicar.valido_de = e}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>

              </MDBCol>

              <MDBCol>

                <FormGroup label="Valido até">
                  <DateInput
                    {...getMomentFormatter("DD/MM/YYYY")}
                    locale="pt-br"
                    dayPickerProps={dayPickerProps}
                    value={this.obs.monofasico_duplicar.valido_ate ? new Date(this.obs.monofasico_duplicar.valido_ate) : null}
                    onChange={(e) => this.obs.monofasico_duplicar.valido_ate = e}
                    placeholder="DD/MM/AAAA"
                    canClearSelection
                  />
                </FormGroup>

              </MDBCol>
            </MDBRow>
          </div>
        </div>

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={this.props.onClose} />
            <Button
              text="Criar uma Cópia"
              onClick={() => this.handleSaveDuplica(this.obs.monofasico_duplicar)}
            />
          </div>
        </div>
      </Dialog>
    );
  }
}